<template>
  <div>
    <div class="d-flex mb-5 flex-wrap">
      <div class="ml-auto">
        <b-button
          class="font-weight-bolder btn-hover-primary-dark"
          variant="primary"
          v-on:click="submit"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/General/Save.svg" /> </span
          >{{ $t("DEVICEEMPLOYEE.SAVE") }}</b-button
        >
      </div>
    </div>
    <CommonFacialDeviceUserTable
      :items="items"
      :pagination="pagination"
      :is-busy="isBusy"
      :caption="caption"
      @changePage="handlePageChange"
      @onChecked="handleCheckbox"
    ></CommonFacialDeviceUserTable>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CommonFacialDeviceUserTable from "@/modules/school/components/device/facial/user/common/CommonFacialDeviceUserTable";

export default {
  name: "SchoolFacialTeacherAvailableTable",
  components: { CommonFacialDeviceUserTable },
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isBusy: false,
      received: [],
      teacher: [],
      caption: {
        main: "All teacher added",
        sub: "To view teacher in this device, go to In",
      },
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      const payload = {
        id: this.device.id,
      };
      this.isBusy = true;
      this.$store
        .dispatch("fetchFDTeacherListNotIn", payload)
        .then(() => {})
        .finally(() => (this.isBusy = false));
    },

    handlePageChange(page) {
      console.log("Current Page is", page);
      this.$store.commit("setFDTeacherListPage", page);
      this.fetch();
    },

    /**
     * Call store to change selected value for item
     */
    handleCheckbox(data, state) {
      console.log("Emitting from checkbox", data.id, state);
      this.$store.dispatch("changeTeacherSelectedStatus", {
        id: data.id,
        currentState: state,
      });
    },

    /**
     * Add teacher into device
     */
    submit() {
      this.items.forEach((e) => {
        if (e.selected) {
          this.teacher.push(e.id);
        }
      });

      console.log("Final Teacher Id: ", this.teacher);

      this.isBusy = true;
      this.$store
        .dispatch("addTeacherInFacialDevice", {
          fd_id: this.device.id,
          school_employee: this.teacher,
        })
        .then(() => {
          this.$bvToast.toast("Successfully add teacher to device.", {
            title: "Success",
            solid: true,
            variant: "success",
            autoHideDelay: 5000,
          });
        })
        .catch(() => {
          this.$bvToast.toast("Failed to add teacher to device.", {
            title: "Failed",
            variant: "danger",
            headerClass: "h4",
            autoHideDelay: 5000,
          });
        })
        .finally(() => {
          this.teacher = [];
          this.isBusy = false;
          this.fetch();
        });
    },
  },

  computed: {
    ...mapGetters({
      items: "getFDTeacherList",
      pagination: "getFDTeacherListPagination",
    }),
  },
};
</script>

<style scoped></style>
